import { LazyReady } from 'components/About/AboutHero'
import { CallToAction } from 'components/CallToAction'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect } from 'react'
import Lottie from 'react-lottie'

export function SupportCTA() {
    const [ready1Data, setReady1Data] = React.useState<any | null>(null)

    useEffect(() => {
        import('../../../static/animations/about-ready-1.json').then((data) => setReady1Data(data.default))
    }, [])

    return (
        <div className="mb-6 flex flex-col items-center justify-center space-y-4 overflow-hidden rounded-md border-t border-b border-dashed border-gray-accent-light px-2 pb-12 dark:border-gray-accent-dark md:max-h-[250px] md:flex-row md:space-x-4 md:space-y-0 md:pt-12">
            <div className="flex-shrink-0">
                {ready1Data ? (
                    <Lottie
                        width={300}
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: ready1Data,
                        }}
                    />
                ) : (
                    <StaticImage width={300} src="../../images/about-ready-1.svg" alt="Ready" placeholder="blurred" />
                )}
            </div>
            <div className="max-w-[400px]">
                <h3 className="m-0">Join the icloud-ready.com support</h3>
                <p className="mt-2 mb-5">
                    Get help or answer questions from the iCloudReady support, vote on the roadmap, and get early access
                    to new features.
                </p>
                <CallToAction size="sm" to="/support">
                    Check it out
                </CallToAction>
            </div>
        </div>
    )
}

export default SupportCTA
